import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore, ProductType } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class PreloadConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getEnabled(): boolean {
		return this.configService.get((x) => x.core.preload.enabled, true);
	}

	getDefaultProductsToPreload(): ProductType[] {
		return this.configService.get((x) => x.core.preload.defaultProducts, [ProductType.Sportsbook]) as ProductType[];
	}
}
